import { createAction } from "@ngrx/store";

const ACTION_PREFIX = "[LEFT MENU]";

export namespace LeftMenuAction {
	export const leftMenuOpen = createAction(`${ACTION_PREFIX} Open`);
	export const leftMenuClose = createAction(`${ACTION_PREFIX} Close`);
}
